import * as React from "react";
import Radium from "radium";
import { size, weight, lineHeight } from "@clockwise/web-commons/src/styles/type.styles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";

const baseStyles = {
  fontSize: size.std,
  lineHeight: lineHeight.std,
  marginBottom: spacing.std,
  fontWeight: weight.std,
};

function PCompt(props: { style?: React.CSSProperties; children?: React.ReactNode }) {
  return <div style={{ ...baseStyles, ...props.style }}>{props.children}</div>;
}
export const P = Radium(PCompt);

const largeStyles = {
  fontSize: size.lg,
  lineHeight: lineHeight.lg,
  marginBottom: spacing.lg,
  fontWeight: weight.std,
};

function P2Compt(props: { style?: React.CSSProperties; children?: React.ReactNode }) {
  return <div style={{ ...largeStyles, ...props.style }}>{props.children}</div>;
}
export const P2 = Radium(P2Compt);
